import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { StyledIcon, SvgSrc } from '~/components/shared/Icon/Icon';
import {
  FontWeights,
  Typography,
} from '~/components/shared/Typography/Typography';
import { MediaQueries } from '~/constants/constVars';
import useTranslate from '~/hooks/useTranslate';
import { confirmSplitPaymentIdle } from '~/store/actions/invoiceActions';
import {
  PaymentMethodBodyContainer,
  PaymentMethodHeaderContainer,
  PaymentMethodMainContainer,
  StepCircle,
} from '../../Invoice';
import { TryAgainContainer } from '../SomethingWentWrong';
import { PaymentRow } from './Instalments/InstalmentCards';
import PaymentMethodsHeader from './PaymentMethodsHeader';

export const GreenCircle = styled.div`
  width: 80px
  height: 80px;
  border: 2px solid #2FD67A;
  border-radius: 50%;
  display: table;
  margin: auto;
  `;

export const CompletedIcon = styled.div`
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  max-width: 27px;
  max-height: 27px;
`;
export const DoneButton = styled.button`
  width: 100%;
  color: white;
  background-color: #214749
  border: none;
  border-radius: 10px;
  height: 47px;
  margin: auto;
  max-width: 310px;
  margin-top: 10px;
  font-size: 18px;
  `;

export const PaymentFrame = styled.div`
  padding: 10px;
  background-color: white;
  border: 2px solid #f2f3f0;
  border-top: 0px;
  border-radius: 10px;
  min-width: 310px;
  width: 350px;
  font-size: 16px;
  @media ${MediaQueries.mediumScreen} {
    width: 500px;
  }
  @media ${MediaQueries.smallScreen} {
    width: auto;
    min-width: auto;
  }
`;

interface Props {
  eachPayment: string;
  date: string;
  onDone: () => void;
}

const PaymentConfirmation: React.FC<Props> = (props) => {
  const { eachPayment, date, onDone } = props;

  const dispatch = useDispatch();
  const translate = useTranslate();
  const onDoneClick = () => {
    dispatch(confirmSplitPaymentIdle());
    onDone();
  };
  return (
    <PaymentMethodMainContainer>
      <PaymentMethodsHeader text="Cancel" hideCancelButton />
      <PaymentMethodBodyContainer>
        <PaymentMethodHeaderContainer>
          <Typography
            lineHeight={1.8}
            fontSize={1.2}
            color="#444444"
            fontWeight={FontWeights.Bold}
          >
            <StepCircle green />
            <StepCircle green />
            <StepCircle green />
            <StepCircle green />
            <br />
            <br />
            <GreenCircle>
              <CompletedIcon>
                <StyledIcon
                  style={{
                    minWidth: '27px',
                    minHeight: '27px',
                    verticalAlign: 'middle',
                  }}
                  color="#2FD67A"
                  icon={SvgSrc.Check}
                />
              </CompletedIcon>
            </GreenCircle>
            <br />
            {translate('Invoices.AllSet')}
          </Typography>
          <Typography color="#444444" fontWeight={FontWeights.Normal}>
            {translate('Invoices.FirstPayment')}
          </Typography>
        </PaymentMethodHeaderContainer>
        <div>
          <PaymentFrame>
            <PaymentRow>
              <Typography style={{ flex: 1 }}>
                {`${translate('Invoices.DueDate')} ${date}`}
              </Typography>
              <Typography
                fontWeight={FontWeights.Bold}
                style={{ float: 'right' }}
              >
                {eachPayment}
              </Typography>
            </PaymentRow>
          </PaymentFrame>
        </div>
        <TryAgainContainer>
          <DoneButton onClick={onDoneClick}>
            {translate('Invoices.Done')}
          </DoneButton>
        </TryAgainContainer>
      </PaymentMethodBodyContainer>
    </PaymentMethodMainContainer>
  );
};

export default PaymentConfirmation;
